var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (fixedWidth, headingSortOrder, headingText) {
if ( headingText)
{
buf.push("<div" + (jade.attr("style", (fixedWidth ? "width: " + (fixedWidth) + "px" : undefined), true, true)) + " class=\"a-to-z-heading\">" + (jade.escape(null == (jade_interp = headingText) ? "" : jade_interp)));
if ( headingSortOrder)
{
buf.push("<div class=\"browse-sort-order\">" + (jade.escape(null == (jade_interp = headingSortOrder) ? "" : jade_interp)) + "</div>");
}
buf.push("</div>");
}
buf.push("<section" + (jade.attr("style", (fixedWidth ? "width: " + (fixedWidth) + "px" : undefined), true, true)) + " class=\"feed-items\"></section>");}.call(this,"fixedWidth" in locals_for_with?locals_for_with.fixedWidth:typeof fixedWidth!=="undefined"?fixedWidth:undefined,"headingSortOrder" in locals_for_with?locals_for_with.headingSortOrder:typeof headingSortOrder!=="undefined"?headingSortOrder:undefined,"headingText" in locals_for_with?locals_for_with.headingText:typeof headingText!=="undefined"?headingText:undefined));;return buf.join("");
};
module.exports = template;